import { createContext, useContext } from 'react';

/**
 * The place in Shell's top bar where the counter POS shows its page title (POS, the terminal, Tables), so the POS
 * spends no row of its own on it. Null where Shell has no such place (every page but the POS).
 */
export const ShellBarContext = createContext<HTMLElement | null>(null);

export function useShellBar(): HTMLElement | null {
  return useContext(ShellBarContext);
}
